import React, { Component } from "react";

const PortfolioListContent = [
    {
        image: 'image-1',
        category: 'Courier Shipping Service ',
        title: 'Parcel comparison website',
        url: 'http://sendo.lv/'
    },
    {
        image: 'image-2',
        category: 'Xop Landing Page',
        title: 'Offline support PWA. Server side rendered.',
        url: 'https://xop.devoflex.com/'
    },
    {
        image: 'image-3',
        category: 'WebGL Experiment',
        title: '3D Mandelburb fractal generator',
        url: 'https://kuprins.com/'
    },
    {
        image: 'image-4',
        category: 'Development',
        title: 'Getting tickets to the big show'
    },
    {
        image: 'image-3',
        category: 'Development',
        title: 'Getting tickets to the big show'
    },
    {
        image: 'image-4',
        category: 'Development',
        title: 'Getting tickets to the big show'
    }
]

class PortfolioList extends Component{
    render(){
        const {column , styevariation } = this.props;
        const list = PortfolioListContent.slice(0 , this.props.item);
        return(
            <React.Fragment> 
                {list.map((value , index) => (
                    <div className={`${column}`} key={index}>
                        <div className={`portfolio ${styevariation}`}>
                            <div className="thumbnail-inner">
                                <div className={`thumbnail ${value.image}`}></div>
                                <div className={`bg-blr-image ${value.image}`}></div>
                            </div>
                            <div className="content">
                                <div className="inner">
                                    <p>{value.category}</p>
                                    <h4><span>{value.title}</span></h4>
                                    <div className="portfolio-button">
                                        <a className="rn-btn" href={value.url}>Open website</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
               
            </React.Fragment>
        )
    }
}
export default PortfolioList;